/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_getValue.js
 ** module id = 1087
 ** module chunks = 0
 **/